import React, { useEffect, useRef, useState } from "react";
import {
    Button, Table, Overlay,
    Popover, Col, Form, Row
} from "react-bootstrap";
import Loader from "../../../Loader/Loader";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { commonService } from "../../../../utils/commonService";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { apiResponse } from "../../../../utils/apiResponse";
import moment from "moment";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import Comments from "../Comments/Comment";
import SingleDateSummaryModal from "../../SingleDateSummaryModal";
import EventViewModal from "../../../CommonComponent/EventViewModal";
import emailIcon from "../../../../Assets/Images/Email.svg";

export const EventStrategy = ({
    setCompDataFromChild,
    rowIndex,
    colIndex,
    api,
    para,
    setting,
}) => {
    const { snapshottitle, propertyCode, snapshotId } = useParams();

    const propertyDetailFromRTK = useSelector((store) => store.headerProperty.propertyDetail);

    const defaultAsOfDateFromRTK = useSelector((store) => store.headerProperty.defaultAsOfDate);

    const [tblids, settblids] = useState({
        eventStrategyTable: commonService.GenerateGUID(),
    });

    const widgetDetailRef = useRef();

    const [widgetModal, setWidgetModal] = useState(false);

    const closeWidgetModal = () => {
        setWidgetModal(false);
    };
    const [ONTHEBOOKS, setONTHEBOOKS] = useState({
        IsDisplay: false,
        Target: null,
        Position: "top",
    });
    const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);
    const [eventData, setEventData] = useState(null);
    const [eventLoading, setEventLoading] = useState(false);
    const eventListRef = useRef();
    const selectedEventDateRef = useRef();
    const eventListPropsRef = useRef();
    const [showTicketModal, setShowTicketModal] = useState(false);
    const selectedTdIndexRef = useRef();
    const singleDateTypeRef = useRef();
    const singleDateSelectedDateRef = useRef();
    const [highDemandLoading, setHighDemandLoading] = useState(false);
    const allEventSourceIdFromDbRef = useRef();
    const sevenDayPickupRef = useRef();

    const handleFilterBtnClick = (event) => {
        let Position = "bottom";
        let Top = event.nativeEvent.layerY - 2;
        if (Top + 400 > window.innerHeight) {
            Position = "top";
        }
        setONTHEBOOKS({
            IsDisplay: true,
            Target: event.target,
            Position: Position,
        });
    };

    const closeTicketModal = () => {
        setShowTicketModal(false);
    };


    const getEventFromDotNet = async () => {
        let eventListResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
                body: {
                    pageNum: 1,
                    pageSize: 10,
                    sortColumn: "",
                    sortDirection: "asc",
                    searchValue: "",
                    propertyid: propertyDetailFromRTK?.propertyid,
                    startdate: null,
                    enddate: null,
                    eventname: "",
                    eventtypeterm: "",
                    yearterm: "",
                },
            },
            false
        );

        let response = apiResponse(false, eventListResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let eventsList = [];

            dataFromApi?.forEach((item) => {
                try {
                    let singleEventObj = {
                        id: item?.eventid ? item?.eventid : 0,
                        name: item?.eventname,
                        detail: item?.eventdetails,
                        startDate: moment(item?.startdate).format("YYYY-MM-DD"),
                        endDate: moment(item?.enddate).format("YYYY-MM-DD"),
                        start: moment(item?.startdate).format("YYYY-MM-DD"),
                        end: moment(item?.enddate).format("YYYY-MM-DD"),
                        title: item?.eventname,
                        eventJson: item?.eventjson,
                        eventResourceId: item?.eventsourceid,
                        backgroundColor: "#ffebeb",
                        textColor: "black",
                        className: "poiter-event-none",
                    };
                    let eventJsonData = "";
                    if (item?.eventjson) {
                        var decodedString = decodeURIComponent(item?.eventjson);
                        const jsonStringWithoutQuotes = decodedString.slice(1, -1);
                        const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
                        eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
                        let desc = eventJsonData?.description?.replaceAll("+", " ");
                        singleEventObj = {
                            ...singleEventObj,
                            labels: eventJsonData?.labels ? eventJsonData?.labels : "",
                            rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
                            local_rank: eventJsonData?.local_rank
                                ? eventJsonData?.local_rank
                                : 0,
                            phq_attendance: eventJsonData?.phq_attendance
                                ? eventJsonData?.phq_attendance
                                : 0,
                            geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
                            geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
                            detail: desc,
                        };
                    }
                    eventsList.push(singleEventObj);
                }
                catch (err) { }
            });
            eventListRef.current = [...eventListRef.current, ...eventsList];
        }

        if (!response?.isValidate) {
        }
    };

    const getEventSourceIdFromDb = async () => {
        setHighDemandLoading(true);
        let eventSourceIdResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.RevenueManagement +
                    API_URL.EVENTS.GET_ALL_EVENT_SOURCE_ID,
                body: {
                    id: propertyDetailFromRTK?.propertyid,
                },
            },
            false
        );

        let response = apiResponse(false, eventSourceIdResponse);

        if (response?.isValidate) {
            let splitArray = response?.data?.data?.split(",");
            allEventSourceIdFromDbRef.current = splitArray;
        }

        if (!response?.isValidate) {
            allEventSourceIdFromDbRef.current = null;
            setHighDemandLoading(false);
        }
    };
    const getEventData = async () => {
        setEventLoading(true);
        eventListRef.current = [];
        await getEventSourceIdFromDb();
        let eventDataResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.REVENUE_GLANCE.TOP_10_EVENT_STRETERGY,
                body: {
                    AsOfDate: asOfDateFromRTK ? asOfDateFromRTK : "",
                    propertyid: propertyDetailFromRTK?.propertyid,
                    propertyCode: propertyCode,
                },
            },
            false
        );

        let response = apiResponse(false, eventDataResponse);

        if (response?.isValidate) {
            let dataFromApi = response?.data?.data;
            let eventNotExistsInDb = [];
            dataFromApi?.forEach((item) => {
                item?.Event_details?.forEach((eventItem) => {
                    let eventExistsInDb = allEventSourceIdFromDbRef.current?.filter(
                        (x) => x === eventItem?.event_id
                    );
                    if (eventExistsInDb?.length <= 0) {
                        let singleEventObj = {
                            id: eventItem?.event_id,
                            name: eventItem?.title,
                            detail: eventItem?.description,
                            startDate: moment(eventItem?.start_date).format("YYYY-MM-DD"),
                            endDate: moment(eventItem?.end_date).format("YYYY-MM-DD"),
                            start: moment(eventItem?.start_date).format("YYYY-MM-DD"),
                            end: moment(eventItem?.end_date).format("YYYY-MM-DD"),
                            title: eventItem?.title,
                            labels: eventItem?.labels,
                            rank: eventItem?.rank ? eventItem?.rank : 0,
                            local_rank: eventItem?.local_rank ? eventItem?.local_rank : 0,
                            phq_attendance: eventItem?.phq_attendance
                                ? eventItem?.phq_attendance
                                : 0,
                            geo_lat: eventItem?.geo_lat ? eventItem?.geo_lat : "",
                            geo_long: eventItem?.geo_long ? eventItem?.geo_long : "",
                            backgroundColor: "#e1e8ff",
                            textColor: "black",
                            className: "poiter-event-none",
                            eventJson: eventItem,
                        };
                        eventNotExistsInDb.push(singleEventObj);
                    }
                });
            });
            eventListRef.current = eventNotExistsInDb;
            await getEventFromDotNet();
            setEventData(response?.data?.data);
            setEventLoading(false);
        }

        if (!response?.isValidate) {
            eventListRef.current = [];
            setEventData(null);
            setEventLoading(false);
        }
    };

    const closeSingleDate = () => {
        selectedTdIndexRef.current = -1;
        setONTHEBOOKS({
            IsDisplay: false,
            Target: null,
            Position: "bottom",
        });
    };

    useEffect(() => {
        if (api === 0) {

        } else {
            getEventData();
        }
    }, [para?.propertyCode]);

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.eventStrategyTable} .perbackground-otb`
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.eventStrategyTable} .perbackground-7DayRms`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.eventStrategyTable} .perbackground-7DayAdr`
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.eventStrategyTable} .perbackground-14DayRms`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.eventStrategyTable} .perbackground-14DayAdr`
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.eventStrategyTable} .perbackground-LyRms`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.eventStrategyTable} .perbackground-LyAdr`
    );

    commonService.setBackColorPerByTDValue(
        "#638EC6",
        "Red",
        `#${tblids.eventStrategyTable} .perbackground-StlyRms`
    );
    commonService.setBackColorPerByTDValue(
        "Green",
        "Red",
        `#${tblids.eventStrategyTable} .perbackground-StlyAdr`
    );

    return (
        <div className="widget-container">
            {api !== 0 && (
                <div className="gap-1 widget-container-menu">
                    <Button
                        className="heading-menu-btns"
                        type="button"
                        title="Send Mail"
                    >
                        <img id={commonService.generateGlobalClickTrackerID("EventStrategy", "emailicon", propertyCode)}
                            src={emailIcon}
                            alt="emailIcon"
                            onClick={() => {
                                commonService.fnSendWidgetMail(
                                    tblids.eventStrategyTable,
                                    "EventStrategy",
                                    snapshotId,
                                    defaultAsOfDateFromRTK,
                                    "",
                                    para?.widgetId
                                );
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("EventStrategy", "info", propertyCode)}
                            src={infoIcon}
                            alt="info"
                            onClick={() => {
                                widgetDetailRef.current = {
                                    widgetdetails: "",
                                    usernote: "",
                                    compName: compName?.EventStrategy,
                                    widgetId: para?.widgetId,
                                };
                                setWidgetModal(true);
                            }}
                        />
                    </Button>
                    <Button className="heading-menu-btns" type="button">
                        <img id={commonService.generateGlobalClickTrackerID("EventStrategy", "menuicon", propertyCode)}
                            src={downloadIcon}
                            alt="menuIcon"
                            import={tblids.eventStrategyTable}
                            onClick={() =>
                                commonService.fnExportInCSV(
                                    tblids.eventStrategyTable,
                                    `${para?.propertyCode}-EventStrategy-${moment(
                                        new Date()
                                    ).format("MMDDYYYY")}`
                                )
                            }
                        />
                    </Button>
                </div>
            )}
            <Row>
                <Col xl={12}>
                    <div className="ViewPropertySetupTable">
                        <div className="stripped__table">
                            <Table id={tblids?.eventStrategyTable} responsive>
                                <thead className="tbl-header-sticky">
                                    <tr className="table-main-header-tr">
                                        <th colSpan={26} className="text-center">
                                            Event Strategy
                                        </th>
                                    </tr>
                                    <tr className="table-main-header-tr">
                                        <th className="border_right"></th>
                                        <th className="border_right"></th>
                                        <th colSpan={5} className="text-center border_right">
                                            On The Books
                                        </th>
                                        <th className="text-center border_right" colSpan={3}>
                                            7 Day Pickup
                                        </th>
                                        <th className="text-center border_right" colSpan={3}>
                                            14 Day Pickup
                                        </th>
                                        <th className="text-center border_right">Forecast</th>
                                        <th
                                            className="text-center border_right"
                                            colSpan={eventData?.[0]?.Rateshop?.length + 1}
                                        >
                                            Rate Shop
                                        </th>
                                        <th className="text-center border_right" colSpan={3}>
                                            Last Year
                                        </th>
                                        <th className="text-center" colSpan={3}>
                                            STLY
                                        </th>
                                    </tr>
                                    <tr className="table-main-header-tr">
                                        <th className=" border_right">Date</th>
                                        <th className="border_right text-center width150">
                                            Events
                                        </th>
                                        <th className="width75 text-center">Left to Sell</th>
                                        <th className="width75 text-center">On The Books</th>
                                        <th className="text-center">Total OCC%</th>
                                        <th className="text-end">ADR</th>
                                        <th className="border_right text-end">Revenue</th>
                                        <th>RMS</th>
                                        <th className="text-end">ADR</th>
                                        <th className="border_right text-end">REV</th>
                                        <th>RMS</th>
                                        <th className="text-end">ADR</th>
                                        <th className="border_right text-end">REV</th>
                                        <th className="border_right text-center">Rooms</th>
                                        {eventData?.[0]?.Rateshop?.map((x, i) => {
                                            if (x.IsSelf === true) {
                                                return (
                                                    <th
                                                        className={`text-end`}
                                                        title={x?.competiterpropertyname}
                                                    >
                                                        {x?.competiterpropertyname?.length > 10
                                                            ? `${x?.competiterpropertyname?.slice(0, 10)}...`
                                                            : x?.competiterpropertyname}
                                                    </th>
                                                );
                                            }
                                        })}
                                        {eventData?.[0]?.Rateshop && <th>Avg Competitor</th>}
                                        {eventData?.[0]?.Rateshop?.map((x, i) => {
                                            if (x.IsSelf === false) {
                                                return (
                                                    <th
                                                        className={`text-end ${eventData?.[0]?.Rateshop?.length - 1 === i
                                                            ? "border_right"
                                                            : ""
                                                            }`}
                                                        title={x?.competiterpropertyname}
                                                    >
                                                        {x?.competiterpropertyname?.length > 10
                                                            ? `${x?.competiterpropertyname?.slice(0, 10)}...`
                                                            : x?.competiterpropertyname}
                                                    </th>
                                                );
                                            }
                                        })}
                                        <th>RMS</th>
                                        <th className="text-end">ADR</th>
                                        <th className="border_right text-end">REV</th>
                                        <th>RMS</th>
                                        <th className="text-end">ADR</th>
                                        <th className="text-end">REV</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {eventLoading ? (
                                        <tr style={{ height: "80px", position: "relative" }}>
                                            <Loader />
                                        </tr>
                                    ) : eventData ? (
                                        eventData?.map((item, index) => {
                                            let checkEvent = eventListRef.current?.filter((x) => {
                                                let checkingDate = moment(item?.Date);
                                                let startingDate = moment(x?.startDate);
                                                let endingDate = moment(x?.endDate);
                                                if (
                                                    checkingDate.isSameOrAfter(startingDate) &&
                                                    checkingDate.isSameOrBefore(endingDate)
                                                ) {
                                                    return x;
                                                }
                                            });
                                            let isSelfData = item?.Rateshop?.filter(
                                                (x) => x?.IsSelf === true
                                            );
                                            let countForRateshopAvg = 0,
                                                rateshopTotal = 0;

                                            item?.Rateshop?.forEach((rateshopItem) => {
                                                if (!rateshopItem?.IsSelf) {
                                                    rateshopTotal =
                                                        rateshopTotal +
                                                        (rateshopItem?.Rate ? rateshopItem?.Rate : 0);

                                                    countForRateshopAvg =
                                                        rateshopItem?.Rate > 0
                                                            ? countForRateshopAvg + 1
                                                            : countForRateshopAvg;
                                                }
                                            });

                                            let avgCompetitor = Math.round(
                                                rateshopTotal / countForRateshopAvg
                                            );

                                            let dayName = false;

                                            if (
                                                moment(new Date(item?.Date), "l").format("ddd") ===
                                                "Fri" ||
                                                moment(new Date(item?.Date), "l").format("ddd") ===
                                                "Sat"
                                            ) {
                                                dayName = true;
                                            }

                                            return (
                                                <>
                                                    <tr
                                                        key={item?.Date}
                                                        className={`shadowOnHover ${dayName ? "backgroundTr" : ""
                                                            }`}
                                                    >
                                                        <td className="border_right">
                                                            {item?.Date
                                                                ? commonService.getDateInFormat(item?.Date)
                                                                : ""}{" "}
                                                            {moment(new Date(item?.Date), "l").format("ddd")}
                                                        </td>
                                                        <td id={commonService.generateGlobalClickTrackerID("EventStrategy", "event-strategy-events", item)}
                                                            className="border_right text-center text-primary cursorPointer"
                                                            title={item?.titles}
                                                            onClick={() => {
                                                                selectedEventDateRef.current = item?.Date;
                                                                eventListPropsRef.current = checkEvent;
                                                                setShowTicketModal(true);
                                                            }}
                                                        >
                                                            {item?.titles?.length > 20
                                                                ? `${item?.titles?.slice(0, 20)}...`
                                                                : item?.titles}
                                                        </td>
                                                        <td className="text-center">
                                                            {item?.OnTheBook?.[0]?.LeftToSell
                                                                ? commonService.formateRoom(
                                                                    item?.OnTheBook?.[0]?.LeftToSell
                                                                )
                                                                : 0}
                                                        </td>
                                                        <td
                                                            className="perbackground perbackground-otb text-primary text-center"
                                                            value={
                                                                item?.OnTheBook?.[0]?.OnTheBook
                                                                    ? item?.OnTheBook?.[0]?.OnTheBook
                                                                    : 0
                                                            }
                                                        >
                                                            <span id={commonService.generateGlobalClickTrackerID("EventStrategy", "event-strategy-on-the-books-on-the", item)}
                                                                className={`${selectedTdIndexRef.current === index &&
                                                                    singleDateTypeRef.current === "event"
                                                                    ? "singleDateSummarySpan"
                                                                    : ""
                                                                    }`}
                                                                onClick={(e) => {
                                                                    singleDateTypeRef.current = "event";
                                                                    singleDateSelectedDateRef.current =
                                                                        item?.Date;
                                                                    handleFilterBtnClick(e);
                                                                    selectedTdIndexRef.current = index;
                                                                }}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                {item?.OnTheBook?.[0]?.OnTheBook
                                                                    ? commonService.formateRoom(
                                                                        item?.OnTheBook?.[0]?.OnTheBook
                                                                    )
                                                                    : 0}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            {item?.OnTheBook?.[0]?.TotalOCCPercentage
                                                                ? item?.OnTheBook?.[0]?.TotalOCCPercentage
                                                                : 0}
                                                            %
                                                        </td>
                                                        <td className="text-end">
                                                            {item?.OnTheBook?.[0]?.ADR
                                                                ? commonService.formateAmount(
                                                                    item?.OnTheBook?.[0]?.ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="border_right text-end">
                                                            {item?.OnTheBook?.[0]?.REV
                                                                ? commonService.formateAmount(
                                                                    item?.OnTheBook?.[0]?.REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td
                                                            className="perbackground perbackground-7DayRms"
                                                            value={
                                                                item?.["7 Day Pickup"]?.[0]?.RMS
                                                                    ? item?.["7 Day Pickup"]?.[0]?.RMS
                                                                    : 0
                                                            }
                                                        >
                                                            {item?.["7 Day Pickup"]?.[0]?.RMS
                                                                ? commonService.formateRoom(
                                                                    item?.["7 Day Pickup"]?.[0]?.RMS
                                                                )
                                                                : 0}
                                                        </td>
                                                        <td
                                                            className="perbackground perbackground-7DayAdr text-end"
                                                            value={
                                                                item?.["7 Day Pickup"]?.[0]?.ADR
                                                                    ? item?.["7 Day Pickup"]?.[0]?.ADR
                                                                    : 0
                                                            }
                                                        >
                                                            {item?.["7 Day Pickup"]?.[0]?.ADR
                                                                ? commonService.formateAmount(
                                                                    item?.["7 Day Pickup"]?.[0]?.ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="border_right text-end">
                                                            {item?.["7 Day Pickup"]?.[0]?.REV
                                                                ? commonService.formateAmount(
                                                                    item?.["7 Day Pickup"]?.[0]?.REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td
                                                            className="perbackground perbackground-14DayRms"
                                                            value={
                                                                item?.["14 Day Pickup"]?.[0]?.RMS
                                                                    ? item?.["14 Day Pickup"]?.[0]?.RMS
                                                                    : 0
                                                            }
                                                        >
                                                            {item?.["14 Day Pickup"]?.[0]?.RMS
                                                                ? commonService.formateRoom(
                                                                    item?.["14 Day Pickup"]?.[0]?.RMS
                                                                )
                                                                : 0}
                                                        </td>
                                                        <td
                                                            className="perbackground perbackground-14DayAdr text-end"
                                                            value={
                                                                item?.["14 Day Pickup"]?.[0]?.ADR
                                                                    ? item?.["14 Day Pickup"]?.[0]?.ADR
                                                                    : 0
                                                            }
                                                        >
                                                            {item?.["14 Day Pickup"]?.[0]?.ADR
                                                                ? commonService.formateAmount(
                                                                    item?.["14 Day Pickup"]?.[0]?.ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="border_right text-end">
                                                            {item?.["14 Day Pickup"]?.[0]?.REV
                                                                ? commonService.formateAmount(
                                                                    item?.["14 Day Pickup"]?.[0]?.REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="border_right text-center">
                                                            {item?.Forecast?.[0]?.RMS
                                                                ? commonService.formateRoom(
                                                                    item?.Forecast?.[0]?.RMS
                                                                )
                                                                : 0}
                                                        </td>
                                                        <td
                                                            className={`text-end ${isSelfData?.[0]?.Rate < avgCompetitor
                                                                ? "greenText"
                                                                : "redText"
                                                                }`}
                                                        >
                                                            {isSelfData?.[0]?.Rate
                                                                ? commonService.formateAmount(
                                                                    isSelfData?.[0]?.Rate
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end">
                                                            {commonService.formateAmount(avgCompetitor)}
                                                        </td>
                                                        {item?.Rateshop?.map((x, i) => {
                                                            if (x.IsSelf === false) {
                                                                return (
                                                                    <td
                                                                        className={`text-end ${item?.Rateshop?.length - 1 === i
                                                                            ? "border_right"
                                                                            : ""
                                                                            }`}
                                                                        title={x?.competiterpropertyname}
                                                                    >
                                                                        {x?.Rate
                                                                            ? commonService.formateAmount(x?.Rate)
                                                                            : commonService.formateAmount(0)}
                                                                    </td>
                                                                );
                                                            }
                                                        })}
                                                        <td
                                                            className="perbackground perbackground-LyRms"
                                                            value={
                                                                item?.LastYear?.[0]?.RMS
                                                                    ? item?.LastYear?.[0]?.RMS
                                                                    : 0
                                                            }
                                                        >
                                                            {item?.LastYear?.[0]?.RMS
                                                                ? commonService.formateRoom(
                                                                    item?.LastYear?.[0]?.RMS
                                                                )
                                                                : 0}
                                                        </td>
                                                        <td
                                                            className="perbackground perbackground-LyAdr text-end"
                                                            value={
                                                                item?.LastYear?.[0]?.ADR
                                                                    ? item?.LastYear?.[0]?.ADR
                                                                    : 0
                                                            }
                                                        >
                                                            {item?.LastYear?.[0]?.ADR
                                                                ? commonService.formateAmount(
                                                                    item?.LastYear?.[0]?.ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="border_right text-end">
                                                            {item?.LastYear?.[0]?.REV
                                                                ? commonService.formateAmount(
                                                                    item?.LastYear?.[0]?.REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td
                                                            className="perbackground perbackground-StlyRms"
                                                            value={
                                                                item?.STLY?.[0]?.RMS ? item?.STLY?.[0]?.RMS : 0
                                                            }
                                                        >
                                                            {item?.STLY?.[0]?.RMS
                                                                ? commonService.formateRoom(
                                                                    item?.STLY?.[0]?.RMS
                                                                )
                                                                : 0}
                                                        </td>
                                                        <td
                                                            className="perbackground perbackground-StlyAdr text-end"
                                                            value={
                                                                item?.STLY?.[0]?.ADR ? item?.STLY?.[0]?.ADR : 0
                                                            }
                                                        >
                                                            {item?.STLY?.[0]?.ADR
                                                                ? commonService.formateAmount(
                                                                    item?.STLY?.[0]?.ADR
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                        <td className="text-end">
                                                            {item?.STLY?.[0]?.REV
                                                                ? commonService.formateAmount(
                                                                    item?.STLY?.[0]?.REV
                                                                )
                                                                : commonService.formateAmount(0)}
                                                        </td>
                                                    </tr>
                                                </>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={50} className="text-center">
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </Col>
            </Row>
            {api !== 0 && <Comments widgetDetails={para} editorId={"EventStrategy"} />}
            {widgetModal && (
                <WidgetDetailModal
                    showModal={widgetModal}
                    closeModal={closeWidgetModal}
                    data={widgetDetailRef.current}
                />
            )}
            <Overlay
                show={ONTHEBOOKS.IsDisplay}
                target={ONTHEBOOKS.Target}
                placement={ONTHEBOOKS.Position}
            >
                <Popover
                    id="popover-contained"
                    className="SingleDateSummaryModalPopoverMain"
                    style={{ zIndex: 999999 }}
                >
                    <div className="horizontal-menu-option active">
                        <SingleDateSummaryModal
                            closeModal={closeSingleDate}
                            asOfDate={asOfDateFromRTK}
                            selectedDate={singleDateSelectedDateRef.current}
                            pickupDate={sevenDayPickupRef.current}
                            propertyDetail={{
                                propertyCode: propertyDetailFromRTK?.propertycode,
                            }}
                        />
                    </div>
                </Popover>
            </Overlay>
            {showTicketModal && (
                <EventViewModal
                    showModal={showTicketModal}
                    closeModal={closeTicketModal}
                    eventDetails={eventListPropsRef.current}
                    selectedDate={selectedEventDateRef.current}
                    getEventList={getEventData}
                />
            )}
        </div>
    );
};


export default EventStrategy;
